export const BASE_WP_API_URL = process.env.NEXT_PUBLIC_BASE_WP_API_URL
export const HOME_PAGE_IDENTIFIER = 'home_page'
